<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>

		<b-row class="mt-3">

			<b-col cols="6">
				<b-form-group
					label="Frequency"
					for="contract_frequency"
				>
					<b-input
						id="contract_frequency"
						type="number"
						v-model="contract.Frequency"
						required
						min="0"
					/>
				</b-form-group>
			</b-col>

			<b-col cols="6">
				<b-form-group
					label="Cost Code"
					for="contract_invoicecode"
				>
					<b-form-select
						id="contract_invoicecode"
						v-model="contract.InvoiceCodeId"
						value-field="Id"
						text-field="Code"
						:options="invoiceCodes"
						required
					>
					</b-form-select>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<hr>
				<b-form-group
					label="Clocks"
					xclass="mt-3  mb-4"
				>
					<b-form-checkbox
						v-for="clock in customerClocks"
						:key="clock.Id"
						:value="clock"
						v-model="contract.Clocks"
						:disabled="clock.Disabled"
						size="lg"
					>{{ clock.Name }} - {{ clock.Address.Town }}</b-form-checkbox>
				</b-form-group>
				<hr>

			</b-col>

			<b-col cols="12">
				<b-form-group
					label="Next Service"
					for="contract_firstservice"
					class="mb-4"
				>

					<b-form-datepicker id="contract_firstservice" v-model="contract.FirstService" required></b-form-datepicker>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<b-button
					type="submit"
					variant="info"
				>
					Add contract
				</b-button>
			</b-col>

		</b-row>

	</b-form>
</template>


<script>
import InvoiceCodeService from "@/api-services/invoicecode.service";
import ContractService from "@/api-services/contract.service";

export default {
	name: "AddContractToParent",

	// things we want to use
	components: {},

	// things we have inherited from our parent
	props: ["customer"],

	created() {
		this.customerClocks = this.customer.Clocks;

		this.customerClocks.map(clock => {
			if (clock.ServiceContractId != null) {
				clock.Disabled = true;
			}
			return clock;
		});

		this.fetchInvoiceCodes();
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			customerClocks: [],

			contract: {
				CustomerId: this.customer.Id,
				InvoiceCodeId: null,
				InvoiceCode: null,
				FirstService: null,
				Frequency: null,
				StateId: 1,
				Clocks: []
			},

			invoiceCodes: []
		};
	},

	// things we do to data
	methods: {
		add() {
			ContractService.create(this.contract)
				.then(response => {
					// push this sucka back to the parent
					let newContract = response.data;
					this.$emit("addContract", newContract);
				})
				.catch(error => {
					console.log(error);
				});
		},

		fetchInvoiceCodes() {
			InvoiceCodeService.getAll().then(response => {
				this.invoiceCodes = response.data;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-contract-to-parent.vue